module.exports = __webpack_public_path__ + "img/error.e238a4fa.svg";